import baseStreamSaga from './base/sagas';

export default [baseStreamSaga];
